import { atomWithQuery } from 'jotai-tanstack-query'
import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { hc } from 'hono/client'
import type { AuthApi } from '@backend/auth'
import { apiFetch, FormError } from '@/lib/apiFetch'

type Store = ReturnType<typeof createStore>
const api = hc<AuthApi>('/api/auth', { fetch: apiFetch })

export const refreshAtom = atomWithQuery(() => ({
  queryKey: ['Invitations', 'list'],
  queryFn: async () => {
    const res = await api.invitations.$get()
    return await res.json()
  },
}))

export const createAtom = atom(null, async (get) => {
  const res = await api.invitations.create.$post()
  if (!res.ok) {
    const body = await res.json().catch(() => ({ message: '生成失败' })) as { message?: string }
    throw new FormError(body.message || '生成失败')
  }
  const data = await res.json()
  await get(refreshAtom).refetch()
  return data
})

export const deleteAtom = atom(null, async (get, _set, code: string) => {
  const res = await api.invitations.delete.$post({ json: { code } })
  if (!res.ok) {
    const body = await res.json().catch(() => ({ message: '删除失败' })) as { message?: string }
    throw new FormError(body.message || '删除失败')
  }
  await get(refreshAtom).refetch()
})

const APP_URL = 'https://fit-time.pages.dev'

export function buildInviteMessage(code: string): string {
  return `你好，我是唐巧，我做了一个极简的健身 App，网址是: ${APP_URL} ，邀请你使用体验。邀请码为：${code}`
}

export function maskPhone(phone: string): string {
  if (phone.length !== 11) return phone
  return `${phone.slice(0, 3)}****${phone.slice(7)}`
}

export function loader(store: Store) {
  store.get(refreshAtom)
  return null
}
